const danhSachDonViNgoaiHeThong = (state) => state.danhSachDonViNgoaiHeThong;

const downloadFileDinhKem = (state) => state.downloadFileDinhKem;

const danhSachVanBanTraLoi = (state) => state.danhSachVanBanTraLoi;

const danhSachDonViChiDao = (state) => state.danhSachDonViChiDao;

const danhSachDonViKyDuyet = (state) => state.danhSachDonViKyDuyet;

const danhSachVanBanDi = (state) => state.danhSachVanBanDi;

const loaiVanBanDi = (state) => state.loaiVanBanDi;

const soLuongVanBanDi = (state) => state.soLuongVanBanDi;

const chiTietVanBanDi = (state) => state.chiTietVanBanDi;

const vanBanDenVanBanDi = (state) => state.vanBanDenVanBanDi;

const multiVanBanDen = (state) => state.multiVanBanDen;

const danhSachNguoiDuocTraLai = (state) => state.danhSachNguoiDuocTraLai;

const listXinSo = (state) => state.listXinSo;

const donViDaBanHanh = (state) => state.donViDaBanHanh;

const lichSuCapNhat = (state) => state.lichSuCapNhat;

const lichSuTraLai = (state) => state.lichSuTraLai;

const lichSuThuHoi = (state) => state.lichSuThuHoi;

const lichSuHuyDuyet = (state) => state.lichSuHuyDuyet;

const luongXuLy = (state) => state.luongXuLy;

const lichSuKyDuyet = (state) => state.lichSuKyDuyet;

const lichSuTheoDoiLienThong = (state) => state.lichSuTheoDoiLienThong;

const donViNgangCap = (state) => state.donViNgangCap;

const nguoiXuLyTiepTheo = (state) => state.nguoiXuLyTiepTheo;

const lichSuTheoDoiVB = (state) => state.lichSuTheoDoiVB;

const dvDaBanHanh = (state) => state.dvDaBanHanh;

const dsSoBiGiu = (state) => state.dsSoBiGiu;

const getSinhSoNoiBo = (state) => state.getSinhSoNoiBo;

const danhSachTrangThaiDashBoardVanBanDi = (state) =>
  state.danhSachTrangThaiDashBoardVanBanDi;

const danhSachMultiVanBanDi = (state) =>
  state.danhSachMultiVanBanDi;

const tempForm = (state) => state.form;
const notReloadList = (state) => state.notReloadList;

const dongChiTietVanBan = (state) => state.dongChiTietVanBan;
const vanBanDenDuThao = (state) => state.vanBanDenDuThao;
const isCaNhan = (state) => state.isCaNhan;
const chuyenVung = (state) => state.chuyenVung;

export default {
  vanBanDenDuThao,
  dongChiTietVanBan,
  notReloadList,
  tempForm,
  danhSachMultiVanBanDi,
  dvDaBanHanh,
  lichSuTheoDoiVB,
  nguoiXuLyTiepTheo,
  donViNgangCap,
  lichSuCapNhat,
  lichSuTraLai,
  lichSuThuHoi,
  danhSachDonViNgoaiHeThong,
  danhSachVanBanTraLoi,
  danhSachDonViChiDao,
  danhSachDonViKyDuyet,
  danhSachVanBanDi,
  loaiVanBanDi,
  soLuongVanBanDi,
  chiTietVanBanDi,
  vanBanDenVanBanDi,
  multiVanBanDen,
  listXinSo,
  danhSachNguoiDuocTraLai,
  donViDaBanHanh,
  lichSuHuyDuyet,
  luongXuLy,
  lichSuKyDuyet,
  danhSachTrangThaiDashBoardVanBanDi,
  lichSuTheoDoiLienThong,
  getSinhSoNoiBo,
  chuyenVung,
  isCaNhan,
};
